document.addEventListener('page:loaded', function() {
  console.log('page:loaded');

  // Wähle das iFrame-Element mit der ID 'looxReviewsFrame'
  var looxIframe = document.getElementById('looxReviewsFrame');

  // Überprüfe, ob das iFrame existiert
  if (looxIframe) {
    // Füge einen Event-Listener hinzu, der auf das 'load'-Event des iFrames wartet
    looxIframe.addEventListener('load', function() {
      console.log('Loox iFrame geladen');

      // Verzögere die Ausführung um 1000ms (1 Sekunde)
      setTimeout(function() {
        // Wähle das Element mit der ID 'looxReviews'
        var looxReviewsElement = document.getElementById('looxReviews');

        // Überprüfe, ob das Element existiert, bevor der Code eingefügt wird
        if (looxReviewsElement) {
            // Erstelle das neue div-Element
            var newDiv = document.createElement('div');
            newDiv.className = 'ndl_legal_review';

            // Erstelle das neue a-Element und setze den Link und den Text
            var newLink = document.createElement('a');
            newLink.href = 'https://google.de';
            newLink.textContent = 'Erfahre, wie wir Bewertungen sammeln.';

            // Füge den Link dem neuen div-Element hinzu
            newDiv.appendChild(newLink);

            // Füge das neue div-Element direkt nach dem looxReviews-Element ein
            looxReviewsElement.insertAdjacentElement('afterend', newDiv);
        }
      }, 1000); // 1000ms Verzögerung
    });
  }

});



// Quick Add To Cart Feature
document.addEventListener('DOMContentLoaded', function() { 
  document.querySelectorAll('.quick-add-button').forEach(button => {
    button.addEventListener('click', function(event) {
        event.preventDefault();

        let spinner = this.querySelector('.spinner');
        let formtrigger = this.parentElement.querySelector('.add-to-cart-trigger');
        let checkmark = document.createElement('div');
        checkmark.classList.add('checkmark');
        checkmark.innerHTML = '&#10003;'; // Unicode Häkchen

        // Spinner anzeigen
        spinner.style.display = 'block';

        // Spinner durch Checkmark ersetzen
        setTimeout(() => {
          spinner.style.display = 'none';
          button.appendChild(checkmark);
        }, 1000);

        // Form Submit auslösen
        formtrigger.click();

    });
  });

  // Form Submit Handler
  document.querySelectorAll('.add-to-cart-trigger').forEach(button => {
    button.addEventListener('click', function(event) {
        event.preventDefault();

        let form = this.closest('form');
        let formData = new FormData(form);
        let icon = this.querySelector('.quick-buy-icon');
        
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            updateCartDrawer();
        })
        .catch(error => {
            console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
            icon.style.opacity = '1';
        });
    });
  });


  // Funktion zum Öffnen des Cart Drawers
  function updateCartDrawer() {
      fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
              document.dispatchEvent(new CustomEvent('cart:open'));
          });
  }

  function addGift() {
    let formData = {
      'items': [{
       'id': theme.settings.freeGiftProduct,
       'quantity': 1
       }]
     };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        updateCartDrawer();
      })
      .catch(error => {
          console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
      });
  }

  document.addEventListener('ajaxProduct:added', function(evt) {
    if(theme.settings.freeGiftEnabled && theme.settings.mainProductForFreeGift && theme.settings.freeGiftProduct) {
      let hasProduct = false;
      let hasGift = false;
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            data.items.forEach(item => {
                console.log(item);
                if (item.id == theme.settings.mainProductForFreeGift) {
                    hasProduct = true;
                }else if (item.id == theme.settings.freeGiftProduct) {
                    hasGift = true;
                }
            });
            if (hasProduct && !hasGift) {
                console.log('add gift');
                addGift();
            }
        });
    } 
  });

});